module.exports = __webpack_public_path__ + "static/motivating-people-d31345c627883fe2177a6d09557de7dd.jpg";